"use strict";

require("core-js/modules/es6.function.name");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDirective = exports.createDirectives = void 0;
var version_1 = require("./version"); // docs: https://v3.cn.vuejs.org/guide/migration/custom-directives.html#_2-x-%E8%AF%AD%E6%B3%95

var hookMap = {
  bind: 'beforeMount',
  inserted: 'mounted',
  update: 'updated',
  componentUpdated: 'updated',
  unbind: 'unmounted'
};
function createDirectives(directives, Vue) {
  if (!(0, version_1.isVue3)(Vue)) {
    return directives;
  }
  var vue3Directives = {};
  Object.keys(directives).forEach(function (name) {
    vue3Directives[name] = createDirective(directives[name], Vue);
  });
  return vue3Directives;
}
exports.createDirectives = createDirectives;
function createDirective(directive, Vue) {
  if (!(0, version_1.isVue3)(Vue)) {
    return directive;
  }
  var vue3Directive = {};
  Object.keys(directive).forEach(function (hook) {
    var vue3Hook = hookMap[hook] || hook;
    vue3Directive[vue3Hook] = directive[hook];
  });
  return vue3Directive;
}
exports.createDirective = createDirective;